<template>
  <div class="goodsManageSet">
    <div class="banner">
      <img src="../../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">商品管理</div>
    </div>
    <div class="tit">属性标签&变量规格式设置</div>

    <div class="input_box search">
      <span class="search_icon" @click="handleSearch"></span>
      <van-field
        v-model="searchTxt"
        ref="input"
        placeholder="输入属性标签关键字查找"
        @focus="handleFocus"
        @blur="handleBlur"
      />
    </div>

    <div class="main_content">
      <div class="data_list" v-if="dataList.length > 0">
        <div
          class="item_card"
          v-for="item in dataList"
          :key="item.id"
          @click="handleEdit(item.id)"
        >
          <div class="img_box">
            <van-image width="100%" height="100%" :src="item.pic"> </van-image>
          </div>
          <div class="text">
            <p>属性标签：{{ item.attrname }}</p>
            <p>属性标签值：{{ item.attrvalue }}</p>
            <p>价格变动值：{{ item.num }}</p>
            <p>是否重点标签：{{ item.isheavy ? "是" : "否" }}</p>
            <p>属性标签状态：{{ item.isuse ? "启用" : "不启用" }}</p>
          </div>
          <div class="block_wrap flex-between">
            <div
              class="block_wrap_item"
              v-if="item.aipic1 != '' && item.aipic1"
            >
              <p>产品正面</p>
              <div class="img_box">
                <van-image width="100%" height="100%" :src="item.aipic1">
                </van-image>
              </div>
            </div>
            <div
              class="block_wrap_item"
              v-if="item.aipic2 != '' && item.aipic2"
            >
              <p>产品背面</p>
              <div class="img_box">
                <van-image width="100%" height="100%" :src="item.aipic2">
                </van-image>
              </div>
            </div>
            <div
              class="block_wrap_item"
              v-if="item.aipic3 != '' && item.aipic3"
            >
              <p>产品局部细节</p>
              <div class="img_box">
                <van-image width="100%" height="100%" :src="item.aipic3">
                </van-image>
              </div>
            </div>
          </div>
          <div class="editBtn">编辑属性标签→</div>
        </div>
      </div>

      <van-empty description="您还没有添加属性标签" v-else />
    </div>

    <!-- <div class="return-fixd flex-rowc" v-if="isShowTabbar">
      <div class="primary-button" @click="handleAdd">+新增属性标签</div>
      <div class="default-button" @click="handleReturn">返回</div>
    </div> -->
    <div class="fixd_button_btm flex-rowl" v-if="isShowTabbar">
      <!-- <div class="return-fixd"> -->
      <div class="item return" @click="handleReturn">返回</div>
      <div class="item" @click="handleAdd">新增属性标签</div>
    </div>
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getShopCommodityAttr } from "../../../api/shop";
import { mapState } from "vuex";
export default {
  name: "cAttrLabel",
  data() {
    return {
      isShowTabbar: true,
      searchTxt: "",

      parantId: "",

      labelList: [],
      dataList: [],
      cmid: "",

      params: {
        pageindex: 1,
        pagesize: 20,
        cmid: "",
      },
      listTotal: 0,
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.params.cmid = id;
        this.getDetail();
      } else {
        this.$router.back();
      }
    },
    getDetail() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getShopCommodityAttr(this.params).then((res) => {
        this.dataList = [...this.dataList, ...res.list];
        this.listTotal = res.total;
        this.loading = false;
        Toast.clear();
      });
    },
    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.pageindex += 1;
        this.getDetail();
      }
    },
    handleSearch() {
      this.getDetail();
    },

    handleReturn() {
      history.back();
    },

    handleEdit(id) {
      let cmId = this.params.cmid;
      // this.$router.push({
      //   path: "/commondityIndex/cManageEdit/cAttrLabelSet",
      //   query: { id, cmId },
      // });
      this.encryptstringadd("cAttrLabelSet", { id, cmId });
    },
    handleAdd() {
      let cmId = this.params.cmid;
      // this.$router.push({
      //   path: "/commondityIndex/cManageEdit/cAttrLabelSet",
      //   query: { cmId },
      // });
      this.encryptstringadd("cAttrLabelSet", { cmId });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .tit {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 50px;
  }
  .input_box {
    &.search {
      margin-bottom: 30px;
    }
  }
  .main_content {
    .item_card {
      border: 2px solid #dedede;
      border-radius: 30px;
      width: 650px;
      padding: 45px 37px 85px;
      box-sizing: border-box;
      margin: auto;
      position: relative;
      margin-bottom: 60px;
      .img_box {
        width: 250px;
        height: 250px;
        margin: auto;
        background: #e8e8e8;
        margin-bottom: 45px;
      }
      .block_wrap_item {
        p {
          text-align: center;

        }
        .img_box {
          height: 150px;
          width: 150px;
        }
      }
      p {
        font-size: 22px;
        color: #404d6c;
        text-align: left;
        line-height: 45px;
      }
      .editBtn {
        position: absolute;
        width: 200px;
        height: 50px;
        line-height: 50px;
        background: #6e5c86;
        border-radius: 25px;
        font-size: 20px;
        color: #fff;
        right: 20px;
        bottom: 20px;
        text-align: center;
      }
    }
  }
}
</style>